function AllBlogs() {
  return <> All Blogs page</>;
}
export default AllBlogs;
